import React from "react";
import Logo from "../../../assets/VAS2Nets-Logo.png";

const LogoComp = () => {
  return (
    <div className="absolute top-4 left-4 bg-white/65 px-4 py-2 rounded-md">
      <img
        src={Logo}
        alt="logo"
        className="h-auto max-h-24 w-auto max-w-40 font-bold"
      />
    </div>
  );
};

export default LogoComp;
